import React from "react";
import "components/Expense/style.css";

export default function Footer() {
  return (
    <>
      <footer className="block bg-white shadow-lg py-2">
        <div className=" mx-auto">
          <hr className="mb-4 border-b-1 border-blueGray-200" />
          <div className="flex flex-wrap items-center md:justify-between justify-center">
            <div className="w-full lg:w-8/12 md:w-6/12 px-3">
              <div
                className="text-sm text-black-900  py-1"
                style={{ fontFamily: "Courier New" }}
              >
                Copyright © {new Date().getFullYear()} Anthem Infotech Private
                Limited. All rights reserved.
              </div>
            </div>
            <div
              className="w-full lg:w-4/12 md:w-6/12 px-3"
              style={{ fontFamily: "Courier New" }}
            >
              <ul className="flex flex-wrap list-none md:justify-end">
                <span className="mr-2 mt-1">Powered by </span>
                <span className="custom-footer">
                  <a
                    href="https://antheminfotech.com/"
                    className="text-white-900 hover:text-white-700 text-sm font-semibold py-1"
                    target="_blank"
                    style={{ color: "white" }}
                  >
                    Anthem Infotech Pvt. Ltd.
                  </a>
                </span>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
